import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import Hero from '@/pages/home/components/Hero';
import CarouselSection from '@/pages/home/components/CarouselSection';
import RankingSection from '@/pages/home/components/RankingSection';
import FaqSection from '@/pages/home/components/FaqSection';
import AppSection from '@/pages/home/components/AppSection';
import MediaSection from '@/pages/home/components/MediaSection';
import FeaturesSection from '@/pages/home/components/FeaturesSection';
import TopicsSection from '@/pages/home/components/TopicsSection';
import IndexSection from '@/pages/home/components/IndexSection';
import AboutSection from '@/pages/home/components/AboutSection';
import CommentsSection from '@/pages/home/components/CommentsSection';
import UpdatesSection from '@/pages/home/components/UpdatesSection';
import ContactSection from '@/pages/home/components/ContactSection';
import CardsSection from '@/pages/home/components/CardsSection';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <CarouselSection />
        <RankingSection />
        <FaqSection />
        <AppSection />
        <MediaSection />
        <FeaturesSection />
        <TopicsSection />
        <IndexSection />
        <AboutSection />
        <CommentsSection />
        <UpdatesSection />
        <ContactSection />
        <CardsSection />
      </main>
      <Footer />
    </>
  );
}